import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import './Spinner.css';
import * as cs from 'classnames';
import { isUndefined } from 'lodash';

export interface SpinnerProps {
    hide: boolean;
}

interface SpinnerState {
    showIcon: boolean;
    timeoutRef?: number;
}

export class Spinner extends React.Component<SpinnerProps, SpinnerState> {

    readonly state: SpinnerState = {showIcon: false};

    componentWillUpdate(nextProps: Readonly<SpinnerProps>, nextState: Readonly<Readonly<{ showIcon: boolean }>>) {
        const {hide} = this.props;
        const {hide: nextHide} = nextProps;
        const {timeoutRef} = this.state;
        if (!hide && nextHide) {
            if (!isUndefined(timeoutRef)) {
                clearTimeout(timeoutRef);
            }
            this.setState(Object.assign({}, this.state, {showIcon: false}));
        }
        if (hide && !nextHide) {
            const ref = setTimeout(() => this.setState(Object.assign({}, this.state, {showIcon: true})), 1000);
            this.setState(Object.assign({}, this.state, {timeoutRef: ref}));
        }
    }

    render() {
        const {showIcon} = this.state;
        const {hide} = this.props;
        return (
            <div className={cs('spinner', {'spinner--hide': hide})}>
                {showIcon ? <FontAwesomeIcon icon={'sync-alt'} className="spinner__logo"/> : null}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/Spinner.tsx